const fiftyFiftyCollage = () => {
    // Single Section Version
    const collages = document.querySelectorAll('[data-fifty-fifty-collage]');
    collages.forEach((collage) => {
        const windowHeight = window.innerHeight;
        const events = ['load', 'resize', 'scroll'];
        events.forEach((event) => {
            window.addEventListener(event, () => {
                const boundingClientRect = collage.getBoundingClientRect();
                const bottom = boundingClientRect.bottom;
                const percentage = (bottom / 2 / windowHeight) * 100;
                const padding = 100 - percentage;
                if (padding < 25) {
                    collage.style.setProperty('--foreground-padding', padding + '%');
                }
            });
        });
    });
    // Blocks Version
    const fiftyFiftyTiles = document.querySelectorAll('[data-collage-tile]');
    fiftyFiftyTiles.forEach((tile) => {
        const tileForground = tile.querySelector('[data-tile-foreground]');
        if (tileForground) {
            const events = ['load', 'resize', 'scroll'];
            events.forEach((event) => {
                window.addEventListener(event, () => {
                    const windowHeight = window.innerHeight;
                    const mediaViewportOffset = tile.getBoundingClientRect();
                    const midPoint = mediaViewportOffset.top + tile.offsetHeight / 2;
                    let percentage = (midPoint / windowHeight) * 100;
                    tileForground.style.setProperty('--width', percentage + '%');
                });
            });
        }
    });
};
export { fiftyFiftyCollage };
